module.exports = __webpack_public_path__ + "videos/colordrop-en.cce4edf.mp4";